import { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import metaDataServices from "../MetaDataServices";

export default function Cue_listing(param: any) { 
    
    let [cuelist, Setcuelist] = useState<any>([]);
    var payLoad = { pageNumber: 1, pageSize: 10 };
    const [openFirst, setOpenFirst] = useState(false);
    let [cueUpsertData, SetcuelUpsertData] = useState<any>([]);

    useEffect(() => {
        metaDataServices.cuelistSearch(payLoad).then((res:any) => {
            cuelist = res
            Setcuelist(cuelist);
        })
    }, [param])

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    const closecue_listing = () => {
        param.onChange();
    }

    const resetCueUpsertForm = () => {

    }

    const selectExistCue = (e:any) => {
        param.onChange(e)
    }
    const saveCueUpsertForm = () => {

    }

    return (<>
        <Modal open={param.productSelect} onClose={() => returnValue(2)}
            styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }}
            center
            classNames={{ overlay: '', modal: 'ws-7 pull-left bgTransparent' }} >
            <div className="box">
                <div className="box-header-main well">
                    <h2>cue</h2>
                </div>

                <div className="ws-12 landing pm">

                    <div className="ws-12 box pm mtl">
                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Master Cue</label>
                            <div className="label-entries">
                                <input className="ws-12" id="masterCue" name="masterCue" type="text" placeholder="Master Cue" value={cueUpsertData && cueUpsertData.masterCue ? cueUpsertData.masterCue : ''} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Sheet Type</label>
                            <div className="label-entries">
                                <select id="cueSheetType" name="cueSheetType">
                                    <option value="">Choose cue sheet type</option>
                                    {global?.cueSheetType?.map((values: any) => {
                                        return (<option className="width200">{values?.cueSheetTypeDesc}</option>)
                                    })}
                                </select>
                            </div>
                        </div>

                        <div className="ws-6 pm">

                            <label className="ws-12 text-bold">Program Number</label>
                            <div className="ws-12">
                                <input className="w-80" id="programNumber" name="programNumber" type="text" placeholder="Program Number" value={cueUpsertData && cueUpsertData.programNumber ? cueUpsertData.programNumber : ''} />
                                <button className="icon-btn info height40 pull-right">Select</button>

                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Production Id</label>
                            <div className="label-entries">
                                <input className="w-80" id="productionId" name="productionId" type="text" placeholder="Production Id" value={cueUpsertData && cueUpsertData.productionId ? cueUpsertData.productionId : ''} />
                                <button className="icon-btn info height30 width90 pull-right"> Select</button>
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Theme</label>
                            <div className="label-entries">
                                <input className="ws-12" id="cueTheme" name="cueTheme" type="text" placeholder="Cue Theme" value={cueUpsertData && cueUpsertData.cueTheme ? cueUpsertData.cueTheme : ''} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Runtime</label>
                            <div className="label-entrieskk">
                                <div className="input-group">
                                    <input className="w-49 text-right" id="runtimeDurationMinute" name="runtimeDurationMinute" type="text" placeholder="Runtime Duration Minute" value={cueUpsertData && cueUpsertData.runtimeDurationMinute ? cueUpsertData.runtimeDurationMinute : ''} />
                                    <input className="w-49 text-right ml" id="runtimeDurationSecond" name="runtimeDurationSecond" type="text" placeholder="Runtime Duration Second" value={cueUpsertData && cueUpsertData.runtimeDurationSecond ? cueUpsertData.runtimeDurationSecond : ''} />
                                </div>
                            </div>
                        </div>

                        <div className="ws-12 pm ">
                            <button type="button" className="icon-btn edit pull-right" onClick={() => saveCueUpsertForm()}>✔ Save</button>
                            <button type="button" className="icon-btn delete pull-right" onClick={() => resetCueUpsertForm()}>↻ Reset</button>
                        </div>

                    </div>

                    <div className="ws-12 box pm mtl allowHscroll allowVscroll forceSingleLine">

                        <div className="ws-12 pbl ">
                            <h4 className="p0 m0 ws-6">1 record(s) found </h4>
                        </div>

                        <table className="newTable mtl">
                            <thead>
                                <tr>
                                    <th >Master Cue</th>
                                    <th >Cue SheetType</th>
                                    <th >Production Id</th>
                                    <th >Program Number</th>
                                    <th >Cue Theme</th>
                                    {false && <th >Cue Status</th>}
                                    {false && <th >Extended Status</th>}
                                    <th >Runtime</th>
                                    <th className="forceSingleLine">Total Songs</th>
                                    <th >Operations</th>
                                </tr>
                            </thead>
                            <tbody>

                                {cuelist.map((row: any) => (
                                    <tr>
                                        <td>{row.masterCue}</td>
                                        <td>{row.cueSheetType}</td>
                                        <td>{row.productionId}</td>
                                        <td>{row.programNumber}</td>
                                        <td>{row.cueTheme}</td>
                                        {false && <td>{row.productStatusName}</td>}
                                        {false && <td>{row.productStatusExtName}</td>}
                                        <td>  {String(row.runtimeDurationMinute).padStart(2, '0')} : {String(row.runtimeDurationSecond).padStart(2, '0')} </td>
                                        <td className="forceSingleLine">
                                            <div className="ws-12">

                                                <div className="ws-3 ptl">
                                                    {row.totalSongs}
                                                </div>

                                                <div className="ws-6 pull-right">
                                                    <button className="icon-btn info pull-right text-center" title="Add Songs to Cue" type="button">
                                                        <i className="icon-plus"> </i>
                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <button className="icon-btn info " title="Edit" type="button" onClick={()=>selectExistCue(row)}>Select  </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>

                        </table>

                    </div>

                    <div className="ws-12 pm ">
                        <button type="button" className="icon-btn delete pull-right" onClick={() => closecue_listing()}>x Close</button>
                    </div>
                </div>
            </div>
        </Modal>

    </>
    )
}